// ANGULAR
import { AfterViewInit, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

// EXTERNAL MODULE
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

// SERVICE
import { EmployeeStoreService } from '../../../../../state/modules/employee/employee-store.service';

// COMPONENTS
import { NotificationComponent } from '../../../../shared/components/modals/notification/notification.component';

// CONSTANTS
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { EMPLOYEE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/employee';
import { ACTIVE_EMPLOYEE_MODAL_CONSTANTS, CUSTOM_SAVE_BUTTON_CONFIG, PERSONAL_DETAIL_FORM_CONTROLS, PERSONAL_DETAIL_FORM_MODEL } from './personal-detail.constant';

// UTILS
import { Router } from '@angular/router';
import moment from 'moment';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription, of } from 'rxjs';
import { Role } from '../../../../../constants/enum/common/role-enum';
import { employeeProfileImageControl } from '../../../../../constants/form-control/employee/personal-detail';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { ModuleType } from '../../../../../constants/lookup/common/module.enum';
import { TimeSheetBreakType } from '../../../../../constants/lookup/timesheet/break-type.enum';
import { TimesheetEnum } from '../../../../../constants/lookup/timesheet/timesheet-status.enum';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { ROUTE_CONSTANTS } from '../../../../../constants/route';
import { AMPLITUDE_EVENT, AmplitudeService } from '../../../../../core/services/amplitude.service';
import { SignalRService } from '../../../../../core/services/signal-r.service';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { DateUtil } from '../../../../../core/utils/date-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalButtonType, ModalType } from '../../../../../models/common/modal/modal-config';
import { MasterStoreService } from '../../../../../state/master/master-store.service';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { UserService } from '../../../../../state/modules/user/services/user.service';
import { FormBaseUtil } from '../../../../shared/components/form-components/base_class/form-utils';
import { DeleteErrorListComponent } from '../../../../standalone/components/delete-error-list/delete-error-list.component';
import { EndBreakComponent } from '../../../shift-info/components/end-break/end-break.component';
import { ScanAreaComponent } from '../../../shift-info/components/scan-area/scan-area.component';
import { ShiftScheduleActualDetailsComponent } from '../../../shift-info/components/shift-schedule-actual-details/shift-schedule-actual-details.component';
import { ShouldEndShiftComponent } from '../../../shift-info/components/should-end-shift/should-end-shift.component';
import { StartBreakComponent } from '../../../shift-info/components/start-break/start-break.component';
import { StartShiftComponent } from '../../../shift-info/components/start-shift/start-shift.component';
import { ShfitFunction } from '../../../shift-info/components/start-shift/start-shift.constant';
import { StartUnscheduledShiftComponent } from '../../../shift-info/components/start-unscheduled-shift/start-unscheduled-shift.component';
import { END_SHIFT_MODAL_CONSTANTS } from '../../../shift-info/pages/shift-info-main/shift-info-main.constant';
import { ShiftInfoMainService } from '../../../shift-info/services/shift-info-main.service';
import { KioskPinComponent } from '../kiosk-pin/kiosk-pin.component';
import { MASTER_MODULE_CONSTANTS } from '../../../../../constants/ngrx-store/master';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';

@Component({
  standalone: false,
  selector: 'kt-personal-detail',
  templateUrl: './personal-detail.component.html',
  styleUrls: ['./personal-detail.component.scss'],
})
export class PersonalDetailComponent extends FormBaseUtil implements OnInit, AfterViewInit {

  timeSheetEnumRef = TimesheetEnum;
  timesheet = null;
  currentStatus = TimesheetEnum.NONE;
  shiftInfo: any = null;
  shiftTimeSheetDetails = null;
  subscriptions: Subscription[] = [];
  showLocationError = false;
  unscheduledShiftData = null;
  reasons = null;
  interval = null;
  timesheetBreak = null;
  _enableShiftControl = false;

  location = {
    latitude: 0,
    logitude: 0,
  };

  counts = {
    shift_form_count: 0,
    // shift_loop_count: 0,
    shift_patrol_count:0,
    shift_reward_count: 0,
    shift_task_group_count: 0,
  };

  activeScreen = {
    mainScreen: true,
    shiftInfo: false,
  };

  timeElapsed = '';
  PermissionV2 = PERMISSIONV2

  /**
    * External inputs
    */
  _screenName;
  @Input() set screenName(value) {
    this._screenName = value;
  }
  @Input() options;
  @Input() set personalDetailform(value) {
    this._personalDetailform = value ? value : new UntypedFormGroup({});
    this._personalDetailform.addControl('employee_id', this.fb.control(0));
  }

  @Input() set employeeInfo(value) {
  }

  @Input() set enableShiftControl(value) {
    this._enableShiftControl = value;
  }

  @Input() set employeeData(value) {
    if (value) {
      this._employeeData = value;
      this.setLoggedInUserProfile();
      if (this._employeeData && this._employeeData.employee_id) {
          this.setExportCodePermission();
        if (this._personalDetailform) {
          this._personalDetailform.get('employee_id').setValue(this._employeeData.employee_id);
          if (this._personalDetailform.get('user_email_address')) {
            this._personalDetailform.get('user_email_address').disable();
          }
        }
      }

      // set value of personal detail form
      let formatedData: any = this.convertModelToFormValue(PERSONAL_DETAIL_FORM_MODEL, this._employeeData);

      if (formatedData && formatedData.user_business_country_code) {
        formatedData.user_business_country_code = formatedData.user_business_country_code || null;
      }

      if (this._personalDetailform) {
        this._personalDetailform.patchValue(formatedData, { emitEvent: true });
      }

      if (formatedData && !formatedData.user_business_country_code) { this.getCountryCodeFromBusiness(); };
    }
  }

  get employeeData() {
    return this._employeeData;
  }

  @Input() clientId = null;
  @Input() locationId = null;

  /**
 * External outputs
 */
  @Output() callback = new EventEmitter<any>();


  /**
   * Constants
   */
  formConstants = PERSONAL_DETAIL_FORM_CONTROLS;
  buttonConstants = CUSTOM_SAVE_BUTTON_CONFIG;
  employeeProfileImageControl = employeeProfileImageControl;

  _personalDetailform: UntypedFormGroup = null;
  _employeeData = null;
  loading = signal(false);
  permissionConstant = PERMISSION_CONSTANT;
  isLoggedInUserProfile = false;
  lookup: any = {};
  isUpdate = false;
  loginEmployeId = null;

  loginUserRole;
  Role = Role;

  constructor(
    private employeeStoreService: EmployeeStoreService,
    private masterStoreService: MasterStoreService,
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private injector: Injector,
    public modalService: NgbModal,
    private scheduleStoreService: ScheduleStoreService,
    private signalRService: SignalRService,
    private timesheetService: TimesheetStoreService,
    public shiftInfoMainService: ShiftInfoMainService,
    private ngxPermissionService: NgxPermissionsService,
  ) {
    super();

    this.loginEmployeId = LocalStorageUtil.getEmployeeId();
    this.loginUserRole = LocalStorageUtil.getUserRole();
  }

  ngOnInit(): void {
   this.dispatchMaster()
  }


  dispatchMaster() {
    this.masterStoreService.dispatchGetCountryCodeList({
      module: MASTER_MODULE_CONSTANTS.COUNTRY_CODE,
      method: API_METHOD_CONSTANTS.GET_LOOKUP,
    });
    this.masterStoreService.dispatchGetCountryList({
      module: MASTER_MODULE_CONSTANTS.COUNTRY,
      method: API_METHOD_CONSTANTS.GET_LOOKUP,
    });
  }

  setScheduleInfo(shiftDetail) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.timeElapsed = '';
    if (shiftDetail) {
      const shiftInfoAndCount = shiftDetail;
      this.shiftTimeSheetDetails = shiftInfoAndCount;
      this.counts.shift_form_count = shiftInfoAndCount.shift_form_count;
      // this.counts.shift_loop_count = shiftInfoAndCount.shift_loop_count;
      this.counts.shift_patrol_count = shiftInfoAndCount.shift_patrol_count;
      this.counts.shift_reward_count = shiftInfoAndCount.shift_reward_count;
      this.counts.shift_task_group_count = shiftInfoAndCount.shift_task_group_count;
      this.timesheet = shiftInfoAndCount.timesheet;
      this.timesheetBreak = shiftInfoAndCount.timesheet_break || {};

      if (this.timesheet) {
        this.currentStatus = this.timesheet.timesheet_shift_status;
        this.unscheduledShiftData = this.timesheet.timesheet_is_unscheduled;
        this.setTimeElapsed();
        this.interval = setInterval(() => {
          this.setTimeElapsed();
        }, 60000);
      } else {
        this.currentStatus = TimesheetEnum.NONE;
      }
      if (shiftInfoAndCount.shift) {
        this.shiftInfo = this.convertDateOfEmployee(shiftInfoAndCount.shift, shiftInfoAndCount.location.location_fk_timezone_name);
        this.setBreakInfo();
      } else {
        this.shiftInfo = null;
      }
    }
  }

  setLoggedInUserProfile() {
    const loginUserId = LocalStorageUtil.getUserId();
    if (loginUserId === this._employeeData.employee_fk_user_id) {
      this.isLoggedInUserProfile = true;
     } 
  }

  kioskClickHandler() {
    const modalRef: NgbModalRef = this.modalService.open(KioskPinComponent, { centered: true, size: 'md', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.userId = (this._employeeData && this._employeeData.employee_fk_user_id) || null;
  }

  setLookup() {
    this.lookup.employee_passport_country = this.masterStoreService.selectCountryList();
    this.lookup.user_business_country_code = this.masterStoreService.selectCountryCodeList();

  }

  /**
   * Delete employee callback
   */
  deleteEmployeeCallback(employee, data) {
    this.loading.set(false);
    if (data.success) {
      if (data.response && data.response.isError) {
        const modalRef: NgbModalRef = this.modalService.open(DeleteErrorListComponent, { centered: true, size: 'lg', keyboard: true, backdrop: 'static' });
        modalRef.componentInstance.data = data.response.data.employees;
        modalRef.componentInstance.module = ModuleType.employee;
        modalRef.result.then(res => {
          if (res && res.force) {
            this.dispatchEmployeeDelete(employee, true);
          }
        })
      } else {
        if (this._screenName === 'Schedule-Employee') {
          this.callback.emit({ type: 'CLOSE' });
          const activeModal = this.injector.get(NgbActiveModal);
          activeModal.close({});
        } else if (this._screenName === 'Approve-Timesheet') {
          this.callback.emit({ type: 'CLOSE' });
          const activeModal = this.injector.get(NgbActiveModal);
          activeModal.close({});
        } else {
          this.router.navigate([ROUTE_CONSTANTS.CONTAINER.MAIN, ROUTE_CONSTANTS.CONTAINER.PEOPLE,]);
        }
        // this.dispatchEmployeeList(this.lastCallPayload);
      }
    }
  }
  archiveClickHandler() {
    const modalRef: NgbModalRef = this.modalService.open(NotificationComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.options = {
      type: ModalType.DELETE,
      title: 'Archive',
      message: 'Are you sure you want to archive this record?',
      buttons: {
        button1: {
          text: 'Archive'
        }
      }
    };

    modalRef.result.then((res) => {
      if (res && res.STATUS === ModalButtonType.DELETE) {
        this.dispatchEmployeeDelete(this._employeeData);

      }
    });
  }

  dispatchEmployeeDelete(data, force = false) {
    this.loading.set(true);
    this.employeeStoreService.dispatchEmployeeCommon({
      callback: this.deleteEmployeeCallback.bind(this, data), data: { id: data.employee_id, is_force_delete: force },
      module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE,
      method: API_METHOD_CONSTANTS.DELETE,
    });
  }

  ngAfterViewInit() {
    this.interval = setInterval(() => {
      this.setTimeElapsed();
    }, 60000);

    // added just to make visible expression work properly
    // setTimeout(() => {
    this._personalDetailform.get('user_business_marital_status').setValue(null);
    this._personalDetailform.get('employee_residency_type').setValue(null);
    // }, 100);

    this.setLookup();
    if (this._employeeData) {
      const formatedData = this.convertModelToFormValue(PERSONAL_DETAIL_FORM_MODEL, this._employeeData);
      if (this._personalDetailform) {
        this._personalDetailform.patchValue(formatedData, { emitEvent: true });
      }
    }

    if (this._personalDetailform.get('user_email_address') && this._employeeData && this._employeeData.employee_id) {
      this._personalDetailform.get('user_email_address').disable();
    }
    this.setExportCodePermission()
    setTimeout(() => {
      const countryCode = this._personalDetailform.get('user_business_country_code') && this._personalDetailform.get('user_business_country_code').value;
      if (!countryCode) { this.getCountryCodeFromBusiness(); };
      this._personalDetailform.get('user_business_mobile_number').setValidators([Validators.pattern('^[0-9]*$')]);
    }, 1000);
  }

  getCountryCodeFromBusiness() {
    const countryIdFromBusiness = LocalStorageUtil.getBusinessCountryId();

    if (this.lookup.user_business_country_code && countryIdFromBusiness) {
      this.subscriptions.push(this.lookup.user_business_country_code.subscribe(c => {
        const country = (c || []).find(x => x.country_id === countryIdFromBusiness);
        if (country) {
          this._personalDetailform?.get('user_business_country_code')?.setValue(country.country_phone_full_code);
        }
      }));
    }
  }

  setExportCodePermission() {
    if (!this._personalDetailform || !this._personalDetailform.get('user_export_code') )
      return

    const exportCodeControl = this._personalDetailform.get('user_export_code');
    const hiddenControl = this._personalDetailform.get('user_export_code_hidden');

    if (this.isLoggedInUserProfile) {
      let viewPermission = this.ngxPermissionService.getPermission(PERMISSIONV2.SELF_PEOPLE_SENSTIVE_DETAILS_ACCESS)
      let permission = this.ngxPermissionService.getPermission(PERMISSIONV2.SELF_PEOPLE_SENSTIVE_DETAILS_MANAGE)

      if (hiddenControl) {
        hiddenControl.setValue(!viewPermission, { emitEvent: false });
      }

      if (!permission) {
        exportCodeControl.disable();
      } else {
        exportCodeControl.enable();
      }
    }
    else {
      let viewPermission = this.ngxPermissionService.getPermission(PERMISSIONV2.PEOPLE_SENSITIVE_DETAILS_ACCESS)
      let permission = this.ngxPermissionService.getPermission(PERMISSIONV2.PEOPLE_SENSITIVE_DETAILS_MANAGE)

      if (hiddenControl) {
        hiddenControl.setValue(!viewPermission, { emitEvent: false });
      }

      if (!permission) {
        exportCodeControl.disable();
      } else {
        exportCodeControl.enable();
      }
    }

  }

  /**
  * Client form change handler
  */
  valueChangeHandler(event) {
    const userEmail = this._personalDetailform.get('user_email_address') && this._personalDetailform.get('user_email_address').value;
    const mobileNumber = this._personalDetailform.get('user_business_mobile_number') && this._personalDetailform.get('user_business_mobile_number').value;
    if (mobileNumber) {
      this._personalDetailform.get('user_business_country_code').setValidators([Validators.required]);
      this._personalDetailform.get('user_business_country_code').updateValueAndValidity();
    } else if (!mobileNumber) {
      this._personalDetailform.get('user_business_country_code').setValidators(null);
      this._personalDetailform.get('user_business_country_code').updateValueAndValidity();
    }

    if (userEmail) {
      this._personalDetailform.get('user_email_address').setValue((userEmail && userEmail.trim()) || '');
      this._personalDetailform.get('user_email_address').updateValueAndValidity();
    }
  }

  /**
   * save the personal Detail of employee
   */
  savePersonalDetail() {
    if (this._personalDetailform.invalid) {
      Object.keys(this._personalDetailform.controls).forEach(controlName =>
        this._personalDetailform.controls[controlName].markAsTouched(),
      );

      return;
    }

    this.loading.set(true);
    const payload: any = this.convertFormValueToModel(PERSONAL_DETAIL_FORM_MODEL, this._personalDetailform.getRawValue());
    payload.user_first_name = payload.user_first_name.trim();
    payload.user_last_name = payload.user_last_name.trim();
    // When added from scheduler
    if (this.clientId && this.locationId) {
      payload.employee_client_id = this.clientId;
      payload.employee_location_id = this.locationId;
    }
    const value = this._personalDetailform.getRawValue()
    if (value.employee_passport_country && value.employee_passport_country.country_name) {
      payload.employee_passport_country = value.employee_passport_country.country_name;
    }

    payload.user_business_country_code = payload.user_business_country_code || null;

    let method = API_METHOD_CONSTANTS.INSERT;

    if (this._employeeData && this._employeeData.employee_id) {
      method = API_METHOD_CONSTANTS.UPDATE;
      this.isUpdate = true;
    }

    // /** dispatch employee common action */
    this.employeeStoreService.dispatchEmployeeCommon({
      callback: this.personalDetailCallBack.bind(this), data: payload,
      module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE_PERSONAL_DETAILS,
      method: method,
    });
  }

  /**
     * callback of employee active api call
     */
  activeEmployeeCallback(data) {
    this.loading.set(false);
    if (data.success) {
      this.callback.emit({ type: 'CLOSE' });
    }
  }

  /**
   * callback of personal detail api call
   */
  personalDetailCallBack(data) {
    this.loading.set(false);
    // if (this.userService.gettingStartedBusinessValue()) {
    //   this.userService.gettingStartedBusiness();
    // }
    if (data.success) {
      // console.log('CHIRAG');
      this._personalDetailform.get('user_email_address').disable();
      this._personalDetailform.markAsPristine();
      if (data.response) {
        this.callback.emit({ data: data.response, type: 'CALLBACK_DATA', isUpdate: this.isUpdate });
        this._personalDetailform.markAsPristine();
      }
    } else if (!data.success && data.error.status === 409) {
      const modalRef: NgbModalRef = this.modalService.open(NotificationComponent);
      modalRef.componentInstance.options = ACTIVE_EMPLOYEE_MODAL_CONSTANTS;
      modalRef.result.then((res) => {
        if (res.STATUS === ModalButtonType.OK) {
          this.loading.set(true);
          this.employeeStoreService.dispatchEmployeeCommon({
            callback: this.activeEmployeeCallback.bind(this), data: { employee_id: data.error.error.data.employees.employee_id },
            module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE,
            method: API_METHOD_CONSTANTS.ACTIVE_USER,
          });
        }
      });
    }
  }

  setTimeElapsed() {
    if (this.timesheet && this.timesheet.timesheet_actual_start_date) {
      // parse start date in its timezone
      const start = moment.tz(this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss', this.shiftTimeSheetDetails.location.location_fk_timezone_name);
      
      // current time in same timezone
      const now = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftTimeSheetDetails.location.location_fk_timezone_name);
      
      const seconds = Math.abs(start.diff(now, 'seconds'));
      
      // const seconds = Math.abs(moment(this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss').diff(moment(), 'seconds', false));
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
      this.timeElapsed = `${hours} Hrs:  ${(+minutes) - ((+hours) * 60)} Mins `;
    }
  }

  setBreakInfo() {
    if (!this.shiftInfo.shift_break) {
      this.shiftInfo.shift_break = [];
    }
    this.shiftInfo.meal_break = this.shiftInfo.shift_break.filter(breakDetail => breakDetail.shift_break_type === BREAK_TYPE_ENUM.MealBreak);
    this.shiftInfo.rest_break = this.shiftInfo.shift_break.filter(breakDetail => breakDetail.shift_break_type === BREAK_TYPE_ENUM.RestBreak);
  }

  convertDateOfEmployee(newEmployee, timezone) {
    newEmployee.shiftStartDate = newEmployee.shift_start_date;
    newEmployee.shiftEndDate = newEmployee.shift_end_date;
    newEmployee.shift_start_date = DateUtil.convertUtcToDateWithLocationTimezone(newEmployee.shift_start_date, timezone);
    newEmployee.shift_end_date = DateUtil.convertUtcToDateWithLocationTimezone(newEmployee.shift_end_date, timezone);
    const fromDateTime = DateUtil.splitDateTime(newEmployee.shift_start_date);
    const toDateTime = DateUtil.splitDateTime(newEmployee.shift_end_date);
    newEmployee.startTime = DateUtil.getTimeToSeconds(fromDateTime.time);
    newEmployee.endTime = DateUtil.getTimeToSeconds(toDateTime.time);
    newEmployee.startDate = fromDateTime.date;
    newEmployee.endDate = toDateTime.date;

    return newEmployee;
  }

  /**
   * Check if we should display kiosk pin button
   */
  // checkForKioskPinVisibility(currentRole, employeeData) {
  //   if (employeeData && employeeData.employee_id && (employeeData.employee_id == this.loginEmployeId) && employeeData.employee_fk_user_id) {
  //     return true;
  //   } else if (currentRole === Role.Location_Manager && !(employeeData && (employeeData.employee_id == this.loginEmployeId)) && ![Role.System_Administrator, Role.Location_Manager].includes(employeeData && employeeData.user_business_role ? employeeData.user_business_role : '')) {
  //     return true;
  //   }
  //   return false;
  // }
}
